class SliderMain {
    constructor(item) {
        // Переменные
        this.element = item;
        this.slider = this.element.querySelector('.js-slider');
        this.tabs = this.element.querySelectorAll('.js-tab');

        // Функции
        this.setListeners();
    };

    setListeners() {
        if (window.innerWidth >= 768) {
            const swiper = new Swiper(this.slider, {
                loop: true,
                effect: 'fade',
                autoplay: {
                    delay: 5000,
                },
            });

            swiper.on('slideChange',() => {
                this.tabs.forEach((item, i) => {
                    if (i === swiper.realIndex) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                })
            });

            this.tabs.forEach((item, i) => {
                item.addEventListener('click', () => {
                    swiper.slideTo(i + 1);
                });
            })
        }
    }
};

document.querySelectorAll('.js-slider-main').forEach((item) => new SliderMain(item));
